<div class="expiredComponent" (window:resize)="onResize($event)">

    <div class="btns-container" style="position:absolute;top:7px;right:1px;">

        <a id="addTagsAssessments" (click)="openAddTagsAssessmentsModal()" [ngClass]="{'btn-primary': _Globals.expiredCanAddTags, 'btn-gray': !_Globals.expiredCanAddTags || selectedRowsCount === 0}" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-tag text-white-50"> <span class="button-text"> Tags</span></i>
        </a>

        <!--<a id="showFilter" (click)="showFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-filter text-white-50"> <span class="button-text"> Search</span></i>
        </a>
        <a id="hideFilter" (click)="hideFilter()" class="d-none d-sm-inline-block btn btn-primary btn-sm  shadow-sm margin-right-5">
            <i class="fas fa-filter text-white-50"> <span class="button-text"> Hide Search</span></i>
        </a>-->
        <a (click)="openExtendModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.expiredCanExtend, 'btn-gray': !_Globals.expiredCanExtend}">
            <i class="fas fa-calendar-day text-white-50"> <span class="button-text"> Update</span></i>
        </a>
        <!--<a (click)="copy()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-other': _Globals.expiredCanCopy, 'btn-gray': !_Globals.expiredCanCopy}">
            <i class="fas fa-copy text-white-50"> <span class="button-text"> Copy link</span></i>
        </a>
        <a *ngIf="_Globals.expiredAssessmentType == 3.2" (click)="assignRaters()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': _Globals.expiredCanAddRaters, 'btn-gray': !_Globals.expiredCanAddRaters}">
            <i class="fas fa-users text-white-50"> <span class="button-text"> Raters</span></i>
        </a>-->
        <a (click)="openConfirmModal()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm" [ngClass]="{'btn-red': _Globals.expiredCanDelete, 'btn-gray': !_Globals.expiredCanDelete}">
            <i class="fas fa-user-times text-white-50"> <span class="button-text"> Unassign</span></i>
        </a>
    </div>


    <div class="container-fluid">

        <ng-container *ngIf="loading">
            <div class="loading text-center">
                <br />
                <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                <br />
                <p>Loading, please wait...</p>
            </div>
        </ng-container>

        <div class="row">

            <div>
                <ul class="nav nav-tabs expiredTabs">
                    <li (click)="tabSelected(3.1)" class="active"><a data-toggle="tab" href="#expiredTab1">ELI - Self Assessment</a></li>
                    <li (click)="tabSelected(3.2)"><a data-toggle="tab" href="#expiredTab2">ELI 360</a></li>
                </ul>
            </div>

            <div class="tab-content expiredTabs">
                <div id="expiredTab1" class="tab-pane fade in active">
                    <div class="row container-fluid">
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(1, $event)"
                                       (onAdd)="onItemAdded(1, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'expiredTagsInput'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('expiredTagsInput')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(1)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="expiredAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="_Globals.expiredRegularData"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         [floatingFilter]="true"
                                         (gridReady)="onGridReady(1, $event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [rowSelection]="rowSelection"
                                         (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                         [rowMultiSelectWithClick]="true">
                        </ag-grid-angular>
                    </div>
                </div>

                <div id="expiredTab2" class="tab-pane fade">
                    <div class="row container-fluid">
                        <!--<div class="col-xs-4 col-sm-offset-5 col-sm-2" >
                            <h5>Search by tag:</h5>
                        </div>-->
                        <div class="col-xs-9 col-sm-5">
                            <tag-input [(ngModel)]='tags360'
                                       [addOnBlur]="true"
                                       (onRemove)="onItemRemoved(2, $event)"
                                       (onAdd)="onItemAdded(2, $event)"
                                       [secondaryPlaceholder]="placeholder"
                                       [placeholder]="placeholder"
                                       [inputId]="'expiredTagsInput360'"
                                       (onFocus)="onFocusInput()"
                                       [theme]="'foundation-theme'"></tag-input>
                            <i class="fas fa-search searchIcon" (click)="focusTagsInput('expiredTagsInput360')"></i>
                            <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(2)">My tags</a>
                        </div>
                        <i style="margin-left: 15px;position: relative;top: 20px;" [popover]="help360" class="fas fa-question-circle pointer"></i>
                        <popover-content #help360
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>

                    <br />

                    <div id="expiredAssessments" style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="_Globals.expired360Data"
                                         [columnDefs]="dataHeaders"
                                         [enableSorting]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         [floatingFilter]="true"
                                         (gridReady)="onGridReady(2, $event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         [rowSelection]="rowSelection"
                                         (selectionChanged)="onSelectionChangedChoiceSet($event)"
                                         [rowMultiSelectWithClick]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>

        <p id="expiredLinkToCopy" style="display:none;"></p>
    </div>
</div>

<!--<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assesments-modal #assignAssessment></app-assign-assesments-modal>-->
<!-- RATERS MODAL -->
<div id="expiredRatersModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center" style="font-weight: bold;">Raters</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body" style="padding-top: 5px;">
                <div class="row">
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <h1 class="h3 mb-0 text-gray-800"></h1>
                        <div class="btns-container">
                            <a (click)="openRaterTypesForModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary margin-right-5">
                                <i class="fas fa-folder-open text-white-50"> <span class="button-text"> Relationships</span></i>
                            </a>
                            <!--<a (click)="sendEmail()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5"
                               [ngClass]="{'btn-primary': _Globals.expiredCanSend, 'btn-gray': !_Globals.expiredCanSend}">
                                <i class="fas fa-send text-white-50"> <span class="button-text"> Send Email</span></i>
                            </a>
                            <a (click)="showImportModal()" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5">
                                <i class="fas fa-file-import text-white-50"> <span class="button-text"> Import raters</span></i>
                            </a>
                            <a (click)="showDeleteRatersConfirmationModal()" class="d-none d-sm-inline-block btn btn-sm  shadow-sm margin-right-5" [ngClass]="{'btn-red': canDeleteRaters, 'btn-gray': !canDeleteRaters}">
                                <i class="fas fa-user-times text-white-50"> <span class="button-text"> Delete</span></i>
                            </a>
                            <a *ngIf="!addingNewRater" (click)="showNewRaterSection('add')" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                                <i class="fas fa-plus text-white-50"> <span class="button-text"> Add</span></i>
                            </a>-->
                        </div>
                    </div>
                </div>

                <div *ngIf="addingNewRater" [@enterAnimation]>
                    <div class="row">
                        <div class="col-xs-12 col-md-2 col-lg-1">
                            <label>Relationship:</label>
                        </div>
                        <div class="col-xs-12 col-md-10 col-lg-11">
                            <select id="relationships" #raterType [(ngModel)]="rater.raterType" (change)="changeFilter()">
                                <option *ngFor="let rt of raterTypes" id="{{rt.Min}}" value="{{rt.Id}}">{{rt.Name}}</option>
                            </select>
                            <span style="position:relative; top:3px; color:red;">You need a minimum of {{categoryMin}} raters for this category.</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-2 col-lg-1">
                            <label>First Name:</label>
                        </div>
                        <div class="col-xs-12 col-md-10 col-lg-11">
                            <input #raterFirstName (keypress)="preventSpace(raterFirstName.value, $event, 'raterFirstName')"
                                   (keyup)="preventSpace(raterFirstName.value, $event, 'raterFirstName')"
                                   id="raterFirstName"
                                   [(ngModel)]="rater.firstName"
                                   placeholder="First Name"
                                   type="text"
                                   name="name"
                                   value="" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-md-2 col-lg-1">
                            <label>Last Name:</label>
                        </div>
                        <div class="col-xs-12 col-md-10 col-lg-11">
                            <input #raterLastName (keypress)="preventSpace(raterLastName.value, $event, 'raterLastName')"
                                   (keyup)="preventSpace(raterLastName.value, $event, 'raterLastName')"
                                   id="raterLastName"
                                   [(ngModel)]="rater.lastName"
                                   placeholder="Last Name"
                                   type="text"
                                   name="last"
                                   value="" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-md-2 col-lg-1">
                            <label>Email:</label>
                        </div>
                        <div class="col-xs-12 col-md-10 col-lg-11">
                            <input #email id="assignedEmail" type="email" placeholder="Email" [(ngModel)]="rater.email" (keypress)="preventSpace(email.value, $event, 'email')" (keyup)="preventSpace(email.value, $event, 'email')" />
                        </div>
                    </div>

                    <br />
                    <div class="text-right">
                        <button (click)="closeNewRaterSection()" type="button" class="btn btn-secondary">Cancel</button>
                        <a (click)="saveNewRater()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5">
                            <i *ngIf="currentAction == 'add'" class="fas fa-plus text-white-50">
                                <span class="button-text"> Add</span>
                            </i>
                            <i *ngIf="currentAction == 'edit'" class="fas fa-pen text-white-50">
                                <span class="button-text"> Update</span>
                            </i>
                        </a>
                    </div>
                    <br />
                    <hr />
                </div>

                <div id="expiredRatersGrid" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #raterAgGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [gridOptions]="raterGridOptions"
                                     [rowData]="raters"
                                     [rowSelection]="ratersRowSelection"
                                     [columnDefs]="ratersHeaders"
                                     (rowClicked)="onRaterRowClicked($event)"
                                     (gridReady)="onRaterGridReadyModal($event)"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="raterOverlayNoRowaTemplate"
                                     (selectionChanged)="onSelectionChangedForRaters($event)">
                    </ag-grid-angular>
                </div>

                <br />
                <div class="text-right" *ngIf="!addingNewRater">
                    <button type="button" (click)="closeModal()" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
                    <button type="button" (click)="saveRaters()" class="btn btn-primary">Save</button>
                </div>
            </div>

            <!--<div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="saveRater()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>-->

        </div>
    </div>
</div>

<!--NEW RATER MODAL-->
<div id="expiredAddModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Rater</h2>
                <button (click)="closeNewRaterModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #language id="expiredLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="expiredDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="schedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="expiredDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 3)" [(ngModel)]="date1" [settings]="settings">
                                </angular2-date-picker> -->
                                <input type="date" [(ngModel)]="date1" (change)="onDateSelect($event, 3)" [min]="getTodayDate2()">
                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="expiredDivHour">
                                <select (change)="importHourChanged()" class="blueSelect" id="expiredHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                                <!--[selected]="hour == '08:00 AM'"-->
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="expiredExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button (click)="closeNewRaterModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="finishSaveRaters()" type="button" class="btn btn-primary">Finish</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE RATERS MODAL*/-->
<div id="expiredConfirmDeleteRatersModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center"><b>Rater(s)</b></h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to delete the selected rater(s)?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Deleting...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirmDeleteRaters()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION MODAL*/-->
<div id="expiredConfirmModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Assessment</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <span *ngIf="!inProgress" style="font-size:17px;">Are you sure you want to unassign the selected assessments?</span>
                <img *ngIf="inProgress" src="../../../assets/img/gif/redLoading.gif" width="50" height="50" alt="In progress..." />
                <p *ngIf="inProgress" style="font-size:12px;">Loading...</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div *ngIf="!inProgress" class="col-md-12 text-center">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="confirm()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*import modal*/-->
<div id="expiredImportRaterModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Import Raters</h2>
                <button type="button" class="close" (click)="closeImportModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div *ngIf="importRaterPageIdx == 0" class="row">
                    <div class="col-xs-3 col-sm-2 text-right">
                        <label><b style="color:#000;">File: </b></label>
                    </div>
                    <div class="col-xs-9 col-sm-10" style="display: inline-flex;">
                        <input type="text" class="input_readonly" style="cursor: default !important;" readonly [(ngModel)]="fileName" />
                        <div class="fileUpload btn btn-primary">
                            <span>...</span>
                            <input accept=".csv" (change)="getBlobFile($event)" type="file" class="upload" id="expiredIFile" />
                        </div>
                    </div>
                </div>

                <div *ngIf="importRaterPageIdx == 1" class="row">
                    <div class="page2">
                        <h5>Language and Dates</h5>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Language: </label>
                            </div>
                            <div class="col-sm-12 col-md-9" style="padding-right: 5px;">
                                <select #importLanguage id="expiredImportLanguages">
                                    <option *ngFor="let language of languages" [value]="language.ShortCode">{{language.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row radios">
                            <div class="col-sm-12 col-md-3 datepicker">
                                <label style="text-align: right;">Schedule for:</label>
                            </div>
                            <div class="col-sm-12 col-md-2" style="padding-right: 5px;" id="expiredImportDatapiker">

                                <label class="container">
                                    Now
                                    <input type="radio" checked="checked" name="expiredSchedule" value="0">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-4 responsiveRadioDiv" style="padding-left: 5px; padding-right: 5px;" id="expiredImportDivHour">
                                <label class="container responsiveRadioLabel">
                                    <span style="margin-left:5px;"></span>
                                    <input type="radio" name="schedule" value="1">
                                    <span style="left: 18px;" class="checkmark"></span>
                                </label>
                                <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event)" [(ngModel)]="importDate" [settings]="settings"></angular2-date-picker> -->
                                <input type="date" [(ngModel)]="importDate" (change)="onDateSelect($event)" [min]="getTodayDate2()">

                            </div>
                            <div class="col-sm-12 col-md-3" style="padding-left: 5px; padding-right: 5px;" id="expiredImportDivHour">
                                <select (change)="importHourChanged()" class="blueSelect" id="expiredImportHour">
                                    <option *ngFor="let hour of hours" [value]="hour">{{hour}}</option>
                                </select>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-3">
                                <label>Expires in:</label>
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <input id="expiredImportExpiresIn" type="number" name="text" value="30" max="30" min="0" />
                                <span>day(s)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="row">
                        <div class="col-md-12">
                            <button *ngIf="importRaterPageIdx == 0" (click)="closeImportModal()" type="button" class="btn btn-secondary">Cancel</button>
                            <button *ngIf="importRaterPageIdx > 0" (click)="importRaterPrev()" type="button" class="btn btn-primary">Previous</button>
                            <button *ngIf="importRaterPageIdx < 1" style="margin-right: 25px;" (click)="importRaterNext()" type="button" class="btn btn-primary">Next</button>
                            <button *ngIf="importRaterPageIdx == 1" style="margin-right: 25px;" (click)="okImportRaters()" type="button" class="btn btn-primary">Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*modal*/-->
<div id="expiredExtendModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" style="max-width: 470px; margin:30px auto;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Update Assignment</h2>
                <button type="button" class="close" (click)="closeExtendModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row d-none">
                    <div class="col-12 col-md-3 text-right">
                        <p>Send on:</p>
                    </div>
                    <div class="col-12 col-md-9 expiredSchedule">
                        <!-- <angular2-date-picker [ngStyle]="{'pointer-events': pointerEvents ? 'auto' : 'none' }" (onDateSelect)="onDateSelect($event, 1)" [(ngModel)]="sentDate" [settings]="settings"></angular2-date-picker> -->
                        <input type="date" [(ngModel)]="sentDate" (change)="onDateSelect($event, 1)" [min]="getTodayDate2()">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-3 text-right">
                        <p>Expires on:</p>
                    </div>
                    <div class="col-12 col-md-9 expired">
                        <!-- NEW DATE PICKER -->
                        <input id="expExpiresDatePicker" type="date" [(ngModel)]="expiresOn" (change)="onDateSelect(expiresOn, 2)" [min]="getTodayDate2()">
                        <!-- NEW DATE PICKER -->
                        <!-- <angular2-date-picker (onDateSelect)="onDateSelect($event, 2)" [(ngModel)]="expiresOn" [settings]="settings"></angular2-date-picker> -->
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeExtendModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="extendExpirationDate()" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*ADD TAGS modal*/-->
<div id="expiredAddTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Add tags</h2>
                <button (click)="closeAddTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row container-fluid">
                    <div class="col-xs-2">
                        <span>Tags</span>
                        <i style="margin-left:0;position:relative;top:0;" [popover]="help" class="fas fa-question-circle pointer"></i>
                        <popover-content #help
                                         title="Tags"
                                         placement="right"
                                         [animation]="true"
                                         [closeOnClickOutside]="true">
                            <p>Create or use existing tags and add them to assigned assessments. Tags can be searched on the Managed Assessment page allowing you to view and select assessments based on any grouping you desire. You can learn more about this feature in Tutorial 6.</p>
                        </popover-content>
                    </div>
                    <div class="col-xs-8" style="margin-top: -10px;">
                        <tag-input [(ngModel)]='addTags'
                                   [addOnBlur]="true"
                                   (onRemove)="onItemRemoved(3, $event, true)"
                                   (onAdd)="onItemAdded(3, $event)"
                                   [secondaryPlaceholder]="placeholder"
                                   [placeholder]="placeholder"
                                   [inputId]="'completedTagsInput'"
                                   (onFocus)="onFocusInput()"
                                   [theme]="'foundation-theme'"></tag-input>
                        <i class="fas fa-search searchIcon" (click)="focusTagsInput('completedTagsInput')"></i>
                    </div>
                    <div class="col-xs-2">
                        <a style="right: 14px; position: absolute; cursor:pointer;text-decoration: underline;" (click)="openTagsModal(3)">My tags</a>
                    </div>

                </div>
            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeAddTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addAssessmentsTags()" [disabled]="assessmentAddTags.length === 0" type="button" class="btn btn-primary">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*MY TAGS modal*/-->
<div id="expiredTagsModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">My tags</h2>
                <button (click)="closeTagsModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div *ngIf="selectedCoachTags.length > 0" class="tags-wrap">
                    <div *ngFor="let tag of selectedCoachTags; let i = index;" class="tag">
                        {{tag.Text}}
                        <span title="Delete" class="animate fadeInRight" (click)="removeTag(i, tag.Text)">&times;</span>
                    </div>
                </div>

                <div *ngIf="selectedCoachTags.length === 0">
                    <input type="text" placeholder="Select tags from the table" id="placeholderInput" readonly />
                </div>

                <div class="table-responsive" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #coachTagsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="gridOptions"
                                     [rowData]="coachTags"
                                     [columnDefs]="coachTagsHeaders"
                                     (gridReady)="onCoachTagsGridReady($event)"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     (rowClicked)="onCoachTagsRowClicked($event)"
                                     (selectionChanged)="onCoachTagsSelectionChanged($event)">
                    </ag-grid-angular>
                </div>

            </div>

            <div class="modal-footer">
                <div>
                    <div class="col-md-12">
                        <button (click)="closeTagsModal()" type="button" class="btn btn-secondary">Cancel</button>
                        <button (click)="addNewCoachTags()" [disabled]="selectedCoachTags.length === 0" type="button" class="btn btn-primary">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--raters types-->
<app-rater-types-for-modal #raterTypesForModal></app-rater-types-for-modal>
